/**
 * Namespace for the web-common-ssr repository.
 * @namespace -Common
 */
import 'core-js/stable';

// import 'core-js/es/global-this';
// import 'regenerator-runtime/runtime';
/**
 * Namespace for the web-common-ssr repository.
 * @namespace -Common
 */
import Routes from '@ulta/core/components/Routes/Routes';
import { renderContainer } from '@ulta/core/utils/dom/dom';
import { isStagingEnvironment } from '@ulta/core/utils/domain/domain';
import { getRenderer } from '@ulta/core/utils/renderer/renderer';

import constants from '@ulta/utils/constants/constants';

export function render(){
  const externalHeader = document.getElementById( constants.HFN.EXTERNAL_HEADER );
  // TODO: get data attributes from header elementID
  const externalFooter = document.getElementById( constants.HFN.EXTERNAL_FOOTER );
  // TODO: get data attributes from footer elementID
  const dsRoot = document.getElementById( constants.APPLICATION_ROOT );

  /*
   * window.__GRAPHQL_DOMAIN__,
   * window.__GRAPHQL_URI__,
   * and window.__TEALIUM_ENVIRONMENT__ are from SSR and should not be removed under any condition
   */
  // Keep this alpha sorted for easier diffs
  const options = {
    ModuleRoutes: Routes,
    renderer: getRenderer( false ),
    allowRootQuerySkip: true,
    amityApiEndpoint: window.__AMITY_API_ENDPOINT__,
    amityClientKey: window.__AMITY_CLIENT_KEY__,
    faqCommunityId: window.__AMITY_FAQ_COMMUNITY_ID__,
    newsCommunityId: window.__AMITY_NEWS_COMMUNITY_ID__,
    termsAndConditionsUrl: window.__AMITY_TERMS_AND_CONDITIONS_URL__,
    privacyAndPolicyUrl: window.__AMITY_PRIVACY_URL__,
    defaultTab: window.__AMITY_DEFAULT_TAB__,
    amityMessageOrigin: window.__AMITY_MESSAGE_ORIGIN__,
    groupQueryString: window.__AMITY_DEEP_LINK_GROUP_QUERY_STRING__,
    userQueryString: window.__AMITY_DEEP_LINK_USER_QUERY_STRING__,
    postQueryString: window.__AMITY_DEEP_LINK_POST_QUERY_STRING__,
    allowUpdateDisplayName: window.__AMITY_UPDATE_DISPLAY_NAME__,
    applePaySessionValidationEndPoint: window.__SERVER_ENDPOINT_APPLEPAY_SESSION_VALIDATION__ || '',
    auth0apiAudience: window.__AUTH0_API_AUDIENCE__ || '',
    auth0callback: window.__AUTH0_CALLBACK__ || '',
    auth0clientId: window.__AUTH0_CLIENT_ID__ || '',
    auth0login: window.__AUTH0_LOGIN__ || '',
    auth0scope: window.__AUTH0_SCOPE__ || '',
    auth0tenant: window.__AUTH0_TENANT__ || '',
    enablePersistentSearch: window.__ENABLE_PERSISTENT_SEARCH__ || false,
    enableSecurityErrorPage: window.__ENABLE_SECURITY_ERROR_PAGE__ || false,
    findationApiKey: window.__FINDATION_API_KEY__ || '',
    findationTestingMode: window.__FINDATION_TESTING_MODE__ || false,
    locale: window.__APP_LOCALE__,
    googleMapsApiKey: window.__GOOGLE_MAPS_API_KEY__ || '',
    graphqlDomain: window.__GRAPHQL_DOMAIN__ || 'https://local.ulta.com:5100',
    graphqlGetUri: window.__GRAPHQL_GET_URI__ || 'dxl/graphql?ultasite=en-us&User-Agent=gomez',
    graphqlPostUri: window.__GRAPHQL_URI__ || 'v1/client/dxl/graphql?ultasite=en-us&User-Agent=gomez',
    graphqlTimeStamp: window.__GRAPHQL_TIMESTAMP__,
    handlePreviewDateCookie: window.__HANDLE_PREVIEW_DATE_COOKIE__ || false,
    inflection: window.__DEVICE_INFLECTION__,
    isBot: window.__IS_BOT__,
    isLocal: window.__IS_LOCAL__,
    isNative: window.__IS_NATIVE__ || false,
    isStaging: window.__IS_STAGING__ || false,
    isPaypalSdkV2: window.__IS_PAYPAL_SDK_V2__ || false,
    paypalEnvironment: window.__PAYPAL_ENVIRONMENT__ || 'sandbox',
    powerReviewsSdk: window.__POWER_REVIEWS_SDK__ || '',
    requestHeaders: window.__REQUEST_HEADERS__ || {},
    previewDate: window.__ULTA_PREVIEW_DATE__ || undefined,
    recentlyViewedLimit: window.__RECENTLY_VIEWED_LIMIT__ || 20,
    recentlyViewedForAutoSuggestionLimit: window.__RECENTLY_VIEWED_FOR_AUTO_SUGEESTION_LIMIT__ || 20,
    rewardsPointsLimit: window.__REWARDS_POINTS_LIMIT__ || 100,
    roktAccountId: window.__ROKT_ACCOUNT_ID__ || '',
    salsifyClientId : window.__SALSIFY_CLIENT_ID__ || '',
    securityErrorStatusCodes: window.__SECURITY_ERROR_STATUS_CODE__ || [],
    serverRouteUtility: window.__SERVER_ROUTE_UTILITY__ || '',
    shoppingAgentCooldownMs: window.__SHOPPING_AGENT_COOLDOWN_MS__ || 2500,
    stagingHost: window.__ULTA_STAGING_HOST__ || undefined,
    stagingWaitingRoomRetryCount: window.__STAGING_WAITING_ROOM_RETRY_COUNT__,
    stagingWaitingRoomRetryInterval: window.__STAGING_WAITING_ROOM_RETRY_INTERVAL__,
    tealiumEnvironment: window.__TEALIUM_ENVIRONMENT__ || 'qa',
    typeaheadMinInputLength: window.__TYPEAHEAD_MIN_INPUT_LENGTH__ || 3,
    websiteDomain: window.__WEBSITE_DOMAIN__,
    enableDynamicPromoBar: window.__ENABLE_DYNAMIC_PROMO_BAR__ || false,
    footerSellMyInfoLinkIcon: window.__FOOTER_SELL_MY_INFO_LINK_ICON__ || ''
  };

  // Patch for dev mode server
  if( process.env.NODE_ENV === 'development' ){
    const url = new URL( global.location.href );
    options.previewDate = url.searchParams.get( 'previewDate' );
    options.stagingHost = url.searchParams.get( 'stagingHost' );
    options.isStaging = isStagingEnvironment( global.location.href );
  }

  const graphqlURI = {
    GET: options.graphqlGetUri,
    POST: options.graphqlPostUri,
    enableGetForQueries: window.__ENABLE_GET_FOR_QUERIES__ || false
  };

  externalHeader &&
  renderContainer( {
    ...options,
    graphqlURI,
    allowRootQuerySkip: false,
    targetElementId: constants.HFN.EXTERNAL_HEADER,
    domElement: externalHeader,
    href: window.location.href,
    isThirdParty: true,
    origin: window.location.origin,
    pathname: constants.HFN.header,
    searchParams: window.location.search
  } );

  externalFooter &&
  renderContainer( {
    ...options,
    graphqlURI,
    adoptSessionExternally: true,
    allowRootQuerySkip: false,
    targetElementId: constants.HFN.EXTERNAL_FOOTER,
    domElement: externalFooter,
    href: window.location.href,
    isThirdParty: true,
    origin: window.location.origin,
    pathname: constants.HFN.footer,
    searchParams: window.location.search
  } );


  dsRoot &&
  renderContainer( {
    ...options,
    graphqlURI,
    domElement: dsRoot,
    href: window.location.href,
    origin: window.location.origin,
    pathname: window.location.pathname,
    searchParams: window.location.search
  } );
}

render();
